module.exports = __webpack_public_path__ + "media/images/dividend/il_coupontheme_mlk-0f9f637219d2f6dd7b209beeb456bb96.svg";